export default (() => {
    let scrollPastToggles = Array.from(document.querySelectorAll('.js-scroll-past-toggle'));

    scrollPastToggles = scrollPastToggles.map((toggle) => ({
        element: toggle,
        target: document.querySelector(`#${toggle.dataset.scrollTarget}`)
    }));

    window.addEventListener('scroll', () => {
        scrollPastToggles.forEach((obj) => {
            const isPassed = obj.target.getBoundingClientRect().top < 0;
            obj.element.classList[isPassed ? 'add' : 'remove']('toggled');
            if (obj.element.getAttribute('aria-hidden')) {
                obj.element.ariaHidden = isPassed ? 'true' : 'false';
            }
        });
    });
})();
